{
  "title": "Earn free months",
  "subtitle.top": "Your recommendation",
  "subtitle.bottom": "means a lot to us!",
  "description": "Your friends, family, and colleagues could also benefit from using Monestry. When they purchase a Monestry subscription, both of you will receive a free month of the plan you have.",
  "paragraphs.0.name": "How does it work?",
  "paragraphs.0.description": "Share the information below with someone. When they purchase a Monestry subscription, both of you will receive an additional month of your plan for free.",
  "paragraphs.1.name": "Registration code is important.",
  "paragraphs.1.description": "The person must register using the link below or the registration code, so that we know to award a free month to you as well.",
  "paragraphs.2.name": "Your personalized invitation.",
  "paragraphs.2.description": "Click the button below to copy the invitation text to your clipboard. You can then paste it into an email or a message.",
  "invitationText": "Check out this website!",
  "invitationText0": "I'd like to invite you to try out Monestry, a trusted financial planning app! Check it out here: http://www.monestry.de/features.",
  "invitationText1": "It's free to try out for 30 days, and if you decide to subscribe, you'll get an additional month for free.",
  "invitationText2": "Use this link to register: https://www.monestry.de/register?registrationCode={{code}} or enter code {{code}}",
  "copyButton.share": "Share",
  "copyButton.copy": "Copy"
}
